export const de = {
  LANGUAGES: {
    English: 'Englisch',
    Russian: 'Russisch',
    Ukrainian: 'Ukrainisch',
    German: 'Deutsch',
  },
  PAGES: {
    CHAT_HISTORY: {
      YOUR_PREVIOUS_CONVERSATION: 'Ihre vorherigen Konversationen',
      SEARCH_BY_NAME: 'Nach Namen suchen',
      PLACEHOLDER_TITLE: 'Keine Ergebnisse für Ihre Suche gefunden',
      PLACEHOLDER_TEXT: 'Versuchen Sie, Ihre Suchparameter zu ändern',
      EMPTY: {
        TITLE: 'Du hast noch keine aktiven Chats',
        TEXT: 'Wähle ein Abenteuer aus Zehntausenden oder erstelle dein eigenes',
        CREATE_CHATBOT: 'Chatbot erstellen',
        GO_TO_CATALOG: 'Zum Katalog',
      },
    },
    SUBSCRIBE: {
      SUBSCRIBE: 'Abonnieren',
      PICK_THE_PLAN: 'Wählen Sie einen Plan oder kaufen Sie Tokens',
      UPGRADE_YOUR_EXPERIENCE: 'Verbessern Sie Ihr Erlebnis und entfesseln Sie Ihre Fantasie mit Premium-Funktionen',
      BUY_TOKENS: 'Tokens kaufen',
      APPLY: 'Anwenden',
      PROMOTIONAL_CODE: 'Aktionscode',
      COMPARE_CAICHAT_FEATURE: 'Vergleichen Sie CAICHAT-Funktionen nebeneinander',
      NO_ADS: 'Keine Werbung',
      SKIP_QUEUES: 'Warteschlangen überspringen',
      CONTEXTUAL_MEMORY_4K: 'Kontextspeicher bis zu 4K Token (ca. 42 Nachrichten)',
      ACCESS_MEMORY_MANAGER: 'Zugriff auf Speicherverwaltung',
      CUSTOM_PERSONAS_10: 'Bis zu 10 benutzerdefinierte Personas',
      CONTEXTUAL_MEMORY_8K: 'Kontextspeicher bis zu 8K Token (ca. 84 Nachrichten)',
      SEMANTIC_MEMORY_2: 'Semantischer Speicher 2.0: automatisches Speichern und Verwenden von Erinnerungen',
      EXTENDED_RESPONSES: 'Erweiterte Antworten bis zu 300 Token',
      IMAGE_GENERATION: 'Bildgenerierung im Gespräch',
      ACCESS_AI_MODELS: 'Zugriff auf zusätzliche KI-Modelle',
      CUSTOM_PERSONAS_50: 'Bis zu 50 benutzerdefinierte Personas',
      CONTEXTUAL_MEMORY_16K: 'Kontextspeicher bis zu 16K Token (ca. 168 Nachrichten)',
      PRIORITY_GENERATION: 'Priorität bei der Antwortgenerierung',
      ACCESS_ADVANCED_MODELS: 'Zugriff auf erweiterte KI-Modelle',
      IMAGE_GENERATION_ALL: 'Bildgenerierung für alle Charaktere, einschließlich privater',
      TEXT_TO_SPEECH: 'Text-to-Speech-Funktion (Sprachantworten)',
      CUSTOM_PERSONAS_100: 'Bis zu 100 benutzerdefinierte Personas',
    },
    MY_PROFILE: {
      BACK: 'Zurück',
      MY_PROFILE: 'Mein Profil',
      SETTINGS: 'Einstellungen',
      LOG_OUT: 'Abmelden',
      TITLE: 'Halt!\n' + 'Ihr persönliches Dashboard wird geladen!',
      TEXT: 'Unser Team arbeitet hart daran, Ihnen ein besonders praktisches Privatkonto zu bieten.\nSchon bald können Sie detaillierte Statistiken einsehen, Ausgaben und Einnahmen verfolgen und vieles mehr.\nBleiben Sie dran!',
    },
    MY_PERSONAS: {
      PLACEHOLDER_1: 'Sie haben noch keine Persona.',
      PLACEHOLDER_2: 'Erstellen Sie eine neue.',
      CREATE_PERSONA: 'Neue Persona erstellen',
    },
    CREATE_PERSONA: {
      PERSONA: 'Persona',
      NAME_PLACEHOLDER: 'Bitte geben Sie den Namen Ihrer Persona ein',
      DESCRIPTION: 'Beschreibung',
      DESCRIPTION_PLACEHOLDER: 'Wie würde sich Ihr Charakter selbst beschreiben?',
      DESCRIPTION_INFO: 'Wird nur in Ihren Konversationen verwendet, um der KI Kontext zu geben. Halten Sie es kurz (1-2 Sätze).',
      VISIBILITY: 'Sichtbarkeit',
      PUBLIC: 'Öffentlich',
      PRIVATE: 'Privat',
      CHECKBOX: 'Als Standard-Persona festlegen',
      ALREADY_DEFAULT: 'Bereits als Standard festgelegt',
      NAME: 'Name',
      SUCCESSFULLY_CREATED: 'Persona erfolgreich erstellt',
      SUCCESSFULLY_UPDATED: 'Persona erfolgreich aktualisiert',
      NO_SPACE_FOR_NEW_PERSONAS: 'Du kannst keine neuen Personas erstellen, bis du Platz freimachst',
    },
    MY_CHATBOTS: {
      NO_CHATBOTS: 'Sie haben noch keine Chatbots erstellt!',
      DO_IT_NOW: 'Tun Sie es jetzt!',
    },
    CHARACTERS: {
      NO_CHARACTERS: 'Keine Ergebnisse für deine Suche gefunden',
      FILTERS: 'Versuche, deine Suchparameter zu ändern oder erstelle deinen eigenen Chatbot',
    },
    PUBLIC_PROFILE: {
      NO_CHATBOTS: 'Dieser Benutzer hat derzeit keine Chatbots',
      TRY_LATTER: 'Versuche es später noch einmal',
    },
    FAVORITES: {
      NO_FAVORITES: 'Du hast derzeit keine Chatbots in deinen Favoriten',
      GO_AND_ADD: 'Gehe zum Katalog und füge Chatbots zu deinen Favoriten hinzu, indem du auf die Schaltfläche klickst',
    },
    CHATBOT_CREATE: {
      UPLOADING: 'Hochladen',
      MODEL_AND_PROMPT: 'Auswahl des KI-Modells und eines System-Prompts',
      IMPORT_CHATBOT: 'Chatbot importieren',
      CHATBOT_AVATAR: 'Chatbot-Avatar',
      UPLOAD_IMAGE_FOR_CHATBOT: 'Bild für Chatbot hochladen',
      CREATE_CHATBOT: 'Chatbot erstellen',
      CHATBOT_NAME: 'Chatbot-Name',
      CHATBOT_DESCRIPTION: 'Chatbot-Beschreibung',
      START_CHAT: 'Chat starten',
      SAVE_CHANGES: 'Änderungen speichern',
      AGREEMENT_TEXT: 'Ich habe die',
      COMMUNITY_GUIDELINES: 'Community-Richtlinien',
      MESSAGE_COST: 'Nachrichtenkosten',
      GENDER: 'Geschlecht',
      VISIBILITY: 'Sichtbarkeit',
      ADD_TAGS: 'Tags hinzufügen',
      SEARCH_TAGS: 'Tags suchen',
      NAME_PLACEHOLDER: 'Chatbot-Namen eingeben',
      DESCRIPTION_PLACEHOLDER:
        'Eine kurze Beschreibung des Chatbots, die im Katalog und in der Vorschau angezeigt wird.<br><br>Dies beeinflusst weder das Gedächtnis noch die Prompts.',
      CREATE_NEW_CHATBOT: 'Neuen Chatbot erstellen',
      EDIT_EXISTING_CHATBOT: 'Bestehenden Chatbot bearbeiten',
      CHATBOT_PROFILE: 'Chatbot-Profil',
      GUIDE: 'Anleitung lesen',
      READ_CREATION_GUIDE: 'Lesen Sie unsere Chatbot-Erstellungsanleitung',
      STATS_TITLE: 'Statistiken',
      HAS_BEEN_STARTED: 'Wurde gestartet:',
      CHAT_TIME: 'Chat-Zeit:',
      USER_MESSAGES: 'Benutzernachrichten:',
      CHARACTER_MESSAGES: 'Charakternachrichten:',
      USER_WORDS: 'Benutzerwörter:',
      CHARACTER_WORDS: 'Charakterwörter:',
      FILL_REQUIRED_FIELDS: 'Es ist notwendig, die Pflichtfelder auszufüllen!',
      MALE: 'Männlich',
      FEMALE: 'Weiblich',
      NON_BINARY: 'Nicht-binär',
      OTHER: 'Sonstiges',
      NOT_SPECIFIED: 'Nicht angegeben',
      PUBLIC: 'Öffentlich',
      PRIVATE: 'Privat',
      VISIBLE_TOOLTIP: 'Öffentlich - für alle sichtbar \n \n Privat - nur für den Autor sichtbar',
      AI_TOOLTIP:
        'KI-Modell: Ein Programm, das darauf trainiert wurde, Text wie ein Mensch zu verstehen und zu generieren. \n \n System-Prompt: Eine versteckte Anweisung, die der KI sagt, wie sie sich verhalten soll.',
      NO_ONLY_EMOJI: 'Name darf nicht nur aus Emojis bestehen',
      COST_DEPENDS: 'Die Kosten hängen von verschiedenen Parametern ab: Modell, Prompt, Begrüßungen, Szenario.',
      PRICE_1_MESSAGE: 'Preis für 1 Nachricht:',
      NOT_AVAILABLE: {
        TITLE: 'Dies ist ein privater Chatbot',
        TEXT: 'Du versuchst, auf einen Link zuzugreifen, der vom Autor eingeschränkt wurde. Du kannst diesen Chatbot nicht ansehen oder mit ihm interagieren.',
        GO_HOME: 'Zur Startseite',
      },
      OTHER_CHATBOTS_BY_AUTHOR: 'Andere Bots von diesem Autor',
      SIMILAR_CHATBOTS: 'Ähnliche Bots',
    },
  },
  MODALS: {
    MODEL_SETTINGS: {
      TITLE: 'Modelleinstellungen',
      ADVANCED_SETTINGS: 'Erweiterte Einstellungen',
      APPLY_SETTINGS: 'Einstellungen übernehmen',
    },
    GENERATE_IMAGE: {
      GENERATE_BACKGROUND: 'Hintergrund generieren',
      GENERATE_AVATAR: 'Avatar generieren',
      ENTER_PROMPT: 'Geben Sie den Prompt ein, um ein Bild zu generieren',
      AGE_ERROR: 'Anfrage abgelehnt: Sicherheitsrichtlinien. Figuren unter 18 Jahren sind nicht erlaubt.',
    },
    CHATBOT_REMOVED: {
      TITLE: 'Chatbot entfernt',
      TEXT: 'Dieser Chatbot wurde vom Autor oder Administrator entfernt. Beginnen Sie jetzt mit anderen Bots zu chatten.',
      GO_HOME: 'Zur Startseite',
    },
    WELCOME: {
      TITLE: 'Willkommen',
      CAN_CHANGE: 'Sie können dies jederzeit ändern',
      HOW_TO_ADDRESS: 'Wie der Chatbot Sie ansprechen wird',
      AGE_AGREE: 'Ich bestätige, dass ich 18 Jahre oder älter bin',
      BOUND_BY: 'Sie stimmen zu, an unsere gebunden zu sein',
    },
    ALLOW_NSFW_CONTENT: {
      TITLE: 'Zugang zu NSFW-Inhalten',
      TEXT: 'Die explizite Ansicht muss in Ihren Kontoeinstellungen aktiviert sein. Nach der Aktivierung können Sie die Sichtbarkeit von NSFW-Inhalten direkt von der Startseite aus steuern.',
      GO_TO_PROFILE: 'Zum Profil',
    },
    CHAT_DECRYPT: {
      TITLE: 'Dieser Chat ist passwortgeschützt',
      TEXT: 'Geben Sie das Passwort ein, um auf den Chat zuzugreifen',
      ENCRYPT_PASSWORD: 'Verschlüsselungspasswort',
      CONFIRM_ENCRYPT_PASSWORD: 'Verschlüsselungspasswort bestätigen',
    },
    CHAT_ENCRYPT: {
      TITLE: 'Ende-zu-Ende-Verschlüsselung',
      NOT_ENCRYPTED: 'Ihr Chat ist nicht verschlüsselt',
      ENCRYPTED: 'Ihr Chat ist verschlüsselt',
      TEXT: 'Nachrichten und Chats sind durch Ende-zu-Ende-Verschlüsselung geschützt. Dritte, einschließlich {{brand}}, können Ihre Nachrichten nicht lesen.',
      ENTER_LABEL:
        'Erstellen Sie ein Verschlüsselungskennwort, wenn Sie die Verschlüsselung für Ihren Chat mit dem Chatbot aktivieren möchten.',
      ENABLE: 'Verschlüsselung aktivieren',
      DISABLE: 'Verschlüsselung deaktivieren',
    },
    CHARACTER_INFO: {
      CHOOSE_A_PERSONA: 'Wählen Sie eine Persona:',
      AI_MODEL_AND_A_SYSTEM_PROMPT: 'KI-Modell und System-Prompt',
      TOOLTIP:
        'KI-Modell: Ein Programm, das darauf trainiert ist, Text wie ein Mensch zu verstehen und zu generieren.\nSystem-Prompt: Eine versteckte Anweisung, die der KI vorgibt, wie sie sich verhalten soll.',
      TAGS: 'Tags',
      START_CHAT: 'Chat starten',
    },
    PASSWORD_RESET: {
      ENTER_NEW_PASSWORD: 'Gib unten ein neues Passwort ein.',
      INVALID_URL: 'Ungültige URL. Bitte fordere eine neue Passwortzurücksetzung an.',
      APPLY_NEW_PASSWORD: 'Neues Passwort übernehmen',
      REQUEST_PASSWORD_RESET: 'Passwortzurücksetzung anfordern',
    },
    IMAGES_GENERATION_SETTINGS: {
      IMAGES_TITLE: 'Bilder',
      NEGATIVE_PROMPT: 'Negativer Prompt',
      NEGATIVE_PROMPT_PLACEHOLDER: 'Schreibe, was du in den Bildern nicht sehen möchtest',
      STYLE_TITLE: 'Stil',
      STYLE_ANIME: 'Anime',
      UNI_STYLE: 'Einheitsstil',
      STYLE_REALISTIC: 'Realistisch',
      GENERATION_OF_NSFW: 'Erzeugung von NSFW-Bildern',
      GENERATION_OF_NSFW_TOOLTIP: 'Aktiviere, um Inhalte für Erwachsene zu sehen.',
      GUIDANCE_SCORE: 'Leitwert',
      CREATIVE: 'Kreativ',
      PRECISE: 'Präzise',
      DISABLE: 'Deaktivieren',
      ENABLE: 'Aktivieren',
    },
    PROFILE_SETTINGS: {
      MY_ACCOUNT: {
        MY_ACCOUNT: 'Mein Konto',
        CHANGE_PERSONA: 'Persona ändern',
        DEFAULT_PERSONA: 'Standard-Persona',
        USERNAME: {
          USERNAME: 'Benutzername',
          PLACEHOLDER: 'Benutzernamen eingeben',
          ERROR: 'Der Benutzername darf nur lateinische Buchstaben (a–z), Zahlen und Bindestriche enthalten',
          ERROR_LENGTH: 'Der Benutzername muss zwischen 3 und 20 Zeichen lang sein.',
        },
        EMAIL: {
          EMAIL: 'E-Mail',
          PLACEHOLDER: 'E-Mail eingeben',
          VERIFIED: 'E-Mail bestätigt',
          VERIFY: 'E-Mail bestätigen',
          NOT_VERIFIED: 'E-Mail nicht bestätigt',
        },
        EMAIL_VERIFICATION: {
          TITLE: 'E-Mail-Bestätigung',
          TEXT_1: 'Eine E-Mail wurde an die Adresse gesendet',
          TEXT_2: 'Bitte klicken Sie auf den Link in dieser E-Mail, um die Bestätigung abzuschließen.',
          NO_CODE: 'Keinen Code erhalten?',
          RESEND: 'Erneut senden',
          SEC: 'Sek.',
          ERROR: 'Fehler beim Senden der Bestätigungs-E-Mail. {{error}}',
        },
        DATE_OF_BIRTH: 'Geburtsdatum',
        DATE_OF_BIRTH_ERROR: 'Das Mindestalter muss mindestens 18 Jahre betragen',
        DESCRIPTION: 'Beschreibung',
        DESCRIPTION_PLACEHOLDER: 'Kurze Beschreibung hier eingeben',
        SOCIALS: 'Soziale Netzwerke',
        ADD_NEW: 'Neu hinzufügen',
        SAVE: 'Speichern',
        SUCCESS: 'Daten erfolgreich gespeichert!',
        FAIL: `Daten konnten nicht gespeichert werden, {{error}}`,
      },
      PREFERENCES: {
        PREFERENCES: 'Einstellungen',
        THEME: {
          THEME: 'Thema',
          SYSTEM: 'System',
          LIGHT: 'Hell',
          DARK: 'Dunkel',
        },
        NSFW: {
          TITLE: 'Chatbots mit expliziten Bildern oder Sprachen anzeigen (NSFW)',
          ERROR: 'Sie können die Anzeige von NSFW-Inhalten nicht aktivieren. Bitte bestätigen Sie, dass Sie 18 Jahre alt sind auf der ',
          LINK: 'Registerkarte „Mein Konto“',
        },
        NOTIFICATIONS: {
          SUCCESS: 'Einstellungen erfolgreich übernommen!',
          FAIL: 'Einstellungen konnten nicht übernommen werden',
        },
      },
      SECURITY: {
        SECURITY: 'Sicherheit',
        TWO_FACTOR: {
          TITLE: 'Zwei-Faktor-Authentifizierung',
          DESCRIPTION: 'Die Zwei-Faktor-Authentifizierung (2FA) bietet einen zuverlässigeren Kontoschutz.',
          DOWNLOAD: 'Laden Sie Google Authenticator herunter',
          APP_DESCRIPTION:
            'Google Authenticator ist ein unabhängiger Dienst von Google Inc., der Ihnen hilft, Ihr Konto zu sichern. Nach der Einrichtung müssen Sie Ihre Anmeldung bei der App oder Auszahlungen mit einem von Google Authenticator generierten Passwort bestätigen.',
          SCAN: 'Scannen Sie den QR-Code oder laden Sie ihn aus dem App Store herunter',
          DOWNLOAD_ON_THE: 'Download auf der',
          WORKS_WITH: 'Funktioniert mit',
          STEP: {
            STEP: 'Schritt',
            ONE: 'Laden Sie die App herunter',
            TWO: 'Fügen Sie den Schlüssel hinzu',
            THREE: 'Code eingeben',
          },
          CONTINUE: 'Weitermachen',
          CONFIRM: 'Bestätigen',
          ADD_KEY: 'Fügen Sie den Schlüssel zu Google Authenticator hinzu und erstellen Sie ein Backup',
          ADD_KEY_TIP:
            'Öffnen Sie Google Authenticator, scannen Sie den QR-Code oder geben Sie den unten stehenden Schlüssel ein, um das Bestätigungstoken hinzuzufügen.',
          SCAN_QR_CODE: 'Scannen Sie den QR-Code oder geben Sie den unten stehenden Schlüssel in die App ein',
          CODE_TIP:
            'Bewahren Sie Ihren Schlüssel für den Fall auf, dass Sie beim Anmelden auf Probleme stoßen, beispielsweise wenn Sie Ihr Telefon verlieren oder andere Probleme auftreten.',
          COPY: 'Kopie',
          COPIED: 'Kopiert',
          ENTER: 'Geben Sie den Code aus der Google Authenticator-App ein.',
          ENTER_TIP: 'Öffnen Sie die GA-App und geben Sie den Bestätigungscode in das Feld unten ein.',
          GA_CODE: 'GA-Code',
          ENTER_CODE: 'Code eingeben',
        },
        PASSWORD: {
          AGO: 'Geändert',
          CURRENT: 'Aktuelles Passwort',
          NEW: 'Neues Passwort',
          CONFIRM: 'Neues Passwort bestätigen',
          SIGN_OUT: 'Von allen aktiven Anmeldungen abmelden',
          CHANGE: 'Kennwort ändern',
          SUCCESS: 'Das Passwort wurde erfolgreich geändert!',
          FAIL: 'Passwort konnte nicht geändert werden, {{error}}',
        },
        SOCIAL: {
          TITLE: 'Anmeldung über soziale Netzwerke',
          DESCRIPTION:
            'Verbinden Sie Ihr CAICHAT.AI-Konto mit Ihren Social-Media-Konten für eine einfache und sichere Anmeldung. Bei der Anmeldung über soziale Netzwerke wird die zweistufige Verifizierung übersprungen, was die Sicherheit Ihres Kontos beeinträchtigen kann.',
          CONNECT: 'Verbinden',
          DISCONNECT: 'Trennen',
          CONNECTED: 'Verbunden',
          NOT_CONNECTED: 'Nicht verbunden',
          NOTIFICATIONS: {
            SUCCESS: '{{providerName}}-Konto erfolgreich getrennt',
            FAIL: 'Konto konnte nicht getrennt werden, {{error}}',
          },
        },
      },
    },
    PAYMENTS: {
      RENEWAL: 'Die Verlängerung erfolgt in {{period}} Tagen für {{price}}/{{period}} Tage. Jederzeit kündbar.',
      SECURE: 'Zahlungen sind sicher und verschlüsselt',
      TOS_1: 'Durch Klicken auf die Schaltfläche "Absenden" bestätigen Sie, dass Sie 18 Jahre oder älter sind und akzeptieren die',
      TOS_2: 'und die',
      TOS_3: '. Wir legen Wert auf den Schutz Ihrer Privatsphäre, daher erscheint die Belastung Ihrer Karte als "{{ brand }}".',
      TOS_4: 'Bei Fragen zu Zahlungen wenden Sie sich bitte an den Kundendienst unter {{ email }}.',
      TOS_5: 'Sie stimmen zu, dass wir Ihre Zahlungsinformationen speichern, damit Sie diese künftig nicht erneut eingeben müssen.',
    },
    DELETE_CHAT: {
      TITLE: 'Chat löschen',
      TEXT: 'Sind Sie sicher, dass Sie diesen Chat löschen möchten? Nach dem Löschen kann er nicht wiederhergestellt werden.',
      SUCCESS: 'Chat erfolgreich gelöscht!',
      FAIL: 'Chat konnte nicht gelöscht werden!',
    },
    DELETE_PERSONA: {
      TITLE: 'Persona löschen',
      TEXT:
        'Das Löschen dieser Persona führt zu irreversiblen Konsequenzen – sie kann nicht wiederhergestellt werden.\n' +
        'Der Verlauf der Kommunikation mit Bots bleibt erhalten und Sie können das Gespräch fortsetzen, jedoch mit einer anderen Persona.\n' +
        '\n',
      SURE: 'Sind Sie sicher, dass Sie dieses Profil löschen möchten?',
      WARNING:
        'Die aktuelle Standard-Persona kann nicht gelöscht werden.\n' +
        'Wählen Sie zunächst eine andere als Standard oder erstellen Sie eine neue.',
      SUCCESS: 'Persona erfolgreich gelöscht!',
      FAIL: 'Persona konnte nicht gelöscht werden!',
    },
    DELETE_CHATBOT: {
      TITLE: 'Chatbot löschen',
      TEXT_1: 'Das Löschen des Chatbots entfernt auch alle Chats und Bilder darin. Diese können nicht wiederhergestellt werden.',
      TEXT_2: 'Sind Sie sicher, dass Sie diesen Chatbot löschen möchten?',
      SUCCESS: 'Chatbot erfolgreich gelöscht!',
      FAIL: 'Chatbot konnte nicht gelöscht werden!',
    },
    BLOCK_CREATOR: {
      TITLE: 'Diesen Autor blockieren?',
      TEXT: 'Sind Sie sicher, dass Sie alle Chatbots dieses Autors blockieren möchten? Sie können die Blockierung jederzeit aufheben.',
      BLOCK: 'Blockieren',
    },
    UNBLOCK_CREATOR: {
      TEXT: 'Sind Sie sicher, dass Sie den Autor entsperren möchten ',
      CANCEL: 'Nein',
      SUCCESS: 'Autor erfolgreich entsperrt!',
      FAIL: 'Fehler beim Entsperren des Autors. Bitte versuchen Sie es später erneut.',
    },
    COMPLAIN: {
      TITLE: 'Beschwerde',
      MAX_CHECKBOXES: 'Sie können maximal 5 Kontrollkästchen auswählen',
      CHECKBOX: {
        THREATS: 'Drohungen und Belästigung',
        CRUELTY: 'Übermäßige Grausamkeit',
        FALSE: 'Falsche Aussagen',
        HATRED: 'Aufstachelung zum Hass',
        NSFW: 'Nicht jugendfrei',
        HARASSMENT: 'Sexuelle Belästigung',
        CHILD_EXPLOIT: 'Ausbeutung von Kindern',
        SELF_HARM: 'Selbstverletzung',
        TERRORISM: 'Terrorismus und Extremismus',
        ILLEGAL: 'Illegale Aktivität',
        DRUGS: 'Drogenhandel',
        CONFIDENTIALITY: 'Verletzung der Vertraulichkeit',
        IMPERSONATION: 'Identitätsmissbrauch',
        SPAM: 'Kommerzieller Spam',
      },
    },
    TELL_US_MORE: {
      TITLE: 'Erzählen Sie uns mehr',
      ADDITIONAL_DETAILS: 'Zusätzliche Details',
      DETAILS_PLACEHOLDER: 'Beschreiben Sie das Problem genauer',
      SUCCESS: 'Ihr Feedback wurde erfolgreich übermittelt!',
      FAIL: 'Feedback konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.',
      FUNNY: 'Lustig',
      HEALTHY: 'Gesund',
      FLIRTY: 'Flirtend',
      INTERESTING: 'Interessant',
      GOOD_MEMORY: 'Gutes Gedächtnis',
    },
    MODEL_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Modell erfolgreich zu Favoriten hinzugefügt',
        FAIL: 'Fehler beim Hinzufügen zu Favoriten, bitte später erneut versuchen.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Modell erfolgreich aus Favoriten entfernt',
        FAIL: 'Fehler beim Entfernen aus Favoriten, bitte später erneut versuchen.',
      },
    },
    PROMPTS_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Prompt erfolgreich zu Favoriten hinzugefügt',
        FAIL: 'Fehler beim Hinzufügen zu Favoriten, bitte später erneut versuchen.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Prompt erfolgreich aus Favoriten entfernt',
        FAIL: 'Fehler beim Entfernen aus Favoriten, bitte später erneut versuchen.',
      },
    },
    MEMORIES: {
      TITLE: 'Erinnerungen',
      PLACEHOLDER_1: 'Hier gibt es noch keine Erinnerungen.',
      PLACEHOLDER_2: 'Chat mit dem Chatbot fortsetzen oder einen neuen erstellen.',
      INPUT_PLACEHOLDER: 'Neue Erinnerung hinzufügen...',
      SUBTITLE: 'Fügen Sie Erinnerungen an Ihre früheren Interaktionen mit der Figur hinzu',
      EDIT: 'Erinnerung bearbeiten',
      DELETE: 'Erinnerung löschen',
      PIN: 'Erinnerung anheften',
      UNPIN: 'Erinnerung lösen',
      PINNED: '(Angeheftet)',
      EDITED: '(bearbeitet)',
      DELETE_TEXT: 'Sind Sie sicher, dass Sie diese Erinnerung löschen möchten? Nach dem Löschen kann sie nicht wiederhergestellt werden.',
      MEMORIES_ENABLED: 'Erinnerungen erfolgreich aktiviert!',
      MEMORIES_DISABLED: 'Erinnerungen erfolgreich deaktiviert!',
      FAILED_TO_UPDATE: 'Aktualisierung der Erinnerungseinstellungen fehlgeschlagen!',
    },
    REGISTRATION: {
      LOGIN_WITH_EMAIL: 'Mit E-Mail einloggen',
      CONTINUE: 'Weiter',
      HAVE_AN_ACCOUNT: 'Bereits ein Konto?',
      DONT_HAVE_AN_ACCOUNT: 'Noch kein Konto?',
      YOU_AGREE: 'Durch die Registrierung stimmen Sie unseren',
      TERMS_AND_CONDITIONS: 'Allgemeinen Geschäftsbedingungen',
      YOU_HAVE_READ: 'zu und haben unsere',
      PRIVACY_POLICY: 'Datenschutzrichtlinie gelesen',
      FORGOT_PASSWORD: 'Passwort vergessen?',
    },
    PASSWORD_RECOVERY: {
      TITLE: 'Passwort wiederherstellen',
      RECOVERY_LINK:
        'Ein Wiederherstellungslink wurde an Ihre E-Mail-Adresse gesendet. Bitte prüfen Sie Ihr Postfach und klicken Sie auf den Link, um Ihr Passwort zurückzusetzen.',
      ENTER_EMAIL: 'Geben Sie die E-Mail-Adresse ein, mit der Sie sich registriert haben, und wir senden Ihnen die Anleitung',
      RESET_PASSWORD: 'Passwort zurücksetzen',
    },
    RESET_PASSWORD: {
      ENTER_PASSWORD: 'Geben Sie in den Feldern unten ein neues Passwort ein',
      APPLY: 'Neues Passwort anwenden',
      ERROR: 'Ungültige URL. Bitte fordern Sie eine neue Zurücksetzung des Passworts an.',
    },
    NONEXISTING: {
      TITLE: 'Ups...',
      TEXT: 'Das, was Sie suchen, könnte woanders sein oder existiert einfach nicht. Bitte versuchen Sie es erneut.',
    },
    CHOOSE_PERSONA: {
      TITLE: 'Persona auswählen',
      SUBTITLE: 'Das Ändern der Persona während eines Gesprächs kann den Erzählfluss unterbrechen.',
      SUCCESS: 'Persona erfolgreich geändert!',
      FAIL: 'Persona konnte nicht geändert werden!',
    },
    IMPORT_CHATBOT: {
      TITLE: 'Chatbot importieren',
      DESCRIPTION: 'Derzeit unterstützen wir den Import von Charakteren von spicychat.ai und juicychat.ai.',
      IMPORT_FROM_FILE: {
        TITLE: 'Import per JSON oder Kartenbild',
        DESCRIPTION: 'Laden Sie eine JSON-Zeichendatei oder ein Bild mit eingebetteten Zeichendaten hoch.',
        SUPPORTED_LABEL: 'Unterstützte Formate:',
        SUPPORTED_FORMATS: 'JSON, PNG, JPG',
        CLICK: 'Klicken Sie hier, um eine Datei auszuwählen oder abzulegen',
      },
      IMPORT_FROM_URL: {
        TITLE: 'Importieren per URL',
        ENTER: 'Geben Sie eine URL von einer unterstützten Website ein',
        CHATBOT_URL: 'Chatbot-URL',
        IMPORT_FROM_URL: 'Von URL importieren',
      },
    },
    BOOSTY_PAYMENT_STATUS: {
      LINK_ACCOUNT: 'Verknüpfen Sie Ihr Boosty-Konto',
      ENTER_EMAIL_DESCRIPTION:
        'Um Ihr Boosty-Abonnement zu bezahlen, geben Sie bitte die mit Ihrem Boosty-Konto verknüpfte E-Mail unten ein',
      EMAIL_WARNING: 'Achtung! Die E-Mail ist mit Ihrem CAICHAT-Konto verknüpft und kann nicht geändert werden',
      EMAIL_LABEL: 'Mit Boosty verknüpfte E-Mail',
      EMAIL_PLACEHOLDER: 'Geben Sie Ihre E-Mail ein',
      WHERE_FIND_EMAIL: 'Wo finde ich meine E-Mail-Informationen auf Boosty?',
      INSTRUCTION_STEP_1: 'Klicken Sie auf Ihren Avatar und wählen Sie "Kontoeinstellungen" aus dem Dropdown-Menü',
      INSTRUCTION_STEP_2:
        'Auf der Registerkarte "Profil" finden Sie Ihre E-Mail. Kopieren Sie sie einfach und fügen Sie sie in das Formular auf dieser Seite ein',
      HAVE_YOU_PAID: 'Haben Sie das Abonnement bezahlt?',
      CONFIRM_PAYMENT_DESCRIPTION:
        'Wenn Sie das Boosty-Abonnement bezahlt haben, bestätigen Sie dies bitte unten. Wir werden die Daten zur Überprüfung synchronisieren.',
      SYNC_FAILED:
        'Synchronisierung fehlgeschlagen. Bitte überprüfen Sie, ob Ihre E-Mail korrekt ist und ob Sie das Boosty-Abonnement erfolgreich bezahlt haben.',
      CONTACT_SUPPORT: 'Wenn Sie Fragen haben oder die angegebene E-Mail ändern müssen, wenden Sie sich bitte an den Support.',
      RETURN_TO_BOOSTY: 'Zurück zur Zahlung auf Boosty',
      I_HAVE_PAID: 'Ich habe bezahlt',
      SUCCESS_PAYMENT: 'Sie haben das Boosty-Abonnement erfolgreich bezahlt!',
      CONGRATULATIONS: 'Herzlichen Glückwunsch! Sie können jetzt mehr Funktionen auf CAICHAT.AI nutzen. Starten Sie jetzt neue Chats!',
      DATA_SYNCHRONIZED: 'Daten synchronisiert',
      SUBSCRIPTION_VALID_UNTIL: 'Abonnement gültig bis',
      MY_PREVIOUS_CHATS: 'Meine vorherigen Chats',
      GO_TO_HOMEPAGE: 'Zur Startseite',
      SYNCHRONIZING_DATA: 'Daten werden synchronisiert',
    },
    TOP_UP: {
      TITLE: 'Laden Sie Ihr Token-Guthaben auf',
      NOT_ENOUGH: 'Sie haben nicht genügend',
      TOKENS: 'Tokens, um Bilder zu generieren.',
      TOP_UP_AND: 'Laden Sie Ihr Guthaben auf und',
      GENERATE_AMAZING_PHOTOS: 'erstellen Sie beeindruckende Fotos',
      RIGHT_IN_THE_CONVERSATION: 'direkt im Gespräch!',
      BUY_TOKENS: 'Tokens kaufen',
    },
  },
  BLOCKS: {
    SORT: {
      MOST_CHATS: 'Die meisten Chats',
      NEWEST: 'Neueste',
      OLDEST: 'Älteste',
      MOST_POPULAR: 'Am beliebtesten',
      MOST_LIKED: 'Am meisten gemocht',
    },
    LEFT_SIDEBAR: {
      HOME: 'Startseite',
      CHATS: 'Chats',
      MY_PERSONAS: 'Meine Personas',
      CREATE_CHATBOT: 'Chatbot Erstellen',
      MY_CHATBOTS: 'Meine Chatbots',
      FAVORITES: 'Favoriten',
      BLOCKED_CREATORS: 'Blockierte Autoren',
      SUBSCRIBE: 'Abonnieren',
      NOTIFICATIONS: 'Benachrichtigungen',
      HELP: 'Hilfe',
    },
    RIGHT_SIDEBAR: {
      UPGRADE_PLAN: 'Tarif upgraden',
      GET_PLAN: 'Abonnement upgraden',
      ACTIVE: 'Aktiv',
      DREAMER: 'Träumer',
      EXPLORER: 'Explorer',
      STORY_GOD: 'Story-Gott',
      NEW_CHAT: 'Neuer Chat',
      EXTENSIONS: 'Erweiterungen',
      CREATE_PRESET: 'Preset erstellen',
      PERSONAS: 'Personas',
      RECENT: 'Kürzlich verwendete KI-Modelle',
      PROMPT: 'Prompt',
      NO_MODEL_SELECTED: 'Kein Modell ausgewählt, um den Chat fortzusetzen',
      SELECT_MODEL_PROMPT: 'Modell und Prompt wählen',
      SELECT_MODEL: 'KI-Modell auswählen',
    },
    CATALOG_FILTER_PANEL: {
      RESET_FILTER: 'Filter zurücksetzen',
      SEARCH_TAGS: 'Tags suchen',
      SHOW: 'Anzeigen',
      CHATBOTS: 'Chatbots',
    },
    SAFE_SEARCH_TOGGLE: {
      SAFE_SEARCH: 'Sichere Suche',
    },
    CHATBOT_INFO: {
      TYPE_GREETING_NAME: 'Begrüßung eingeben',
      ADD_NEW_GREETING: 'Neue Begrüßung hinzufügen',
      GREETINGS: 'Begrüßungen',
      PERSONALITY: 'Persönlichkeit',
      SCENARIO: 'Szenario',
      DIALOG: 'Dialog',
      NOTES: 'Autorennotiz',
      DESCRIPTION: 'Beschreibung',
      AVATAR: 'Avatar',
      NAME: 'Name',
      GREETINGS_PLACEHOLDER:
        'Zum Beispiel: Die berühmte Archäologin mit geheimnisvoller Vergangenheit, Elara Nightshade, hat Jahrzehnte damit verbracht, vergessene Tempel und antike Ruinen auf der ganzen Welt zu erforschen. Mit ihrem charakteristischen silbergestreiften schwarzen Haar und durchdringenden bernsteinfarbenen Augen genießt sie Respekt in akademischen Kreisen und bewahrt dabei eine Aura des Geheimnisvollen.',
      PERSONALITY_PLACEHOLDER:
        'Beschreibe die Persönlichkeit des Charakters, Eigenschaften, Hintergrund, Sprachstil usw. Verwende klare, prägnante Sprache. Beispiele: „witzig und sarkastisch“, „spricht immer in Reimen“, „hat Angst vor Spinnen“, „ehemaliger Detektiv, von einem alten Fall verfolgt“.',
      SCENARIO_PLACEHOLDER: 'Beschreibe das Szenario für den Charakter. Verwende klare, prägnante Sprache.',
      DIALOG_PLACEHOLDER:
        "Gib ein Beispiel für einen Dialog, der zeigt, wie der Charakter spricht. Verwende das Format: 'Benutzer: Hallo\nCharakter: [Antwort des Charakters]'. Füge mehrere Austausche hinzu, um den Kommunikationsstil zu demonstrieren.",
      NOTES_PLACEHOLDER: 'Schreibe eine kurze Erklärung für Benutzer, wie sie am besten mit diesem Bot interagieren',
      CHAT_BACKGROUND: 'Chat-Hintergrund',
      DELETE_CHAT_BACKGROUND: 'Chat-Hintergrund löschen',
      HIDE_THIS_BLOCK: 'Diesen Block ausblenden',
    },
    TOKENIZATOR: {
      TOKENS: 'Tokens',
    },
    BLOCK_BUTTON: {
      NO_BLOCKED: 'Du hast keine blockierten Autoren',
      SHARE: 'Teilen',
      DELETE_CHATBOT: 'Diesen Chatbot löschen',
      EDIT: 'Bearbeiten',
      BLOCK_CREATOR: 'Autor blockieren',
      UNBLOCK_CREATOR: 'Autor freischalten',
      VOICE_OVER: 'Sprachwiedergabe',
      REGENERATE_MESSAGE: 'Nachricht neu generieren',
      NEW_CHAT_FROM_HERE: 'Neuen Chat von hier starten',
      REPORT: 'Melden',
      REPORT_CHATBOT: 'Chatbot melden',
      DELETE_IMAGE: 'Bild löschen',
      BLOCK_SUCCESS: 'Benutzer erfolgreich blockiert',
      BLOCK_ERROR: 'Benutzer konnte nicht blockiert werden. Bitte versuche es später erneut.',
      UNBLOCK_SUCCESS: 'Benutzer erfolgreich freigeschaltet',
      UNBLOCK_ERROR: 'Benutzer konnte nicht freigeschaltet werden. Bitte versuche es später erneut.',
      IMAGE_SETTINGS: 'Bildeinstellungen',
      RATE_MESSAGE: 'Nachricht bewerten',
    },

    CHAT_INPUT: {
      ACTION: 'Aktion',
      TYPE_YOUR_MESSAGE: 'Gib deine Nachricht ein...',
      EDIT_MESSAGE_PLACEHOLDER: 'Nachricht bearbeiten...',
      DELETED_PERSONA_PLACEHOLDER: 'Ihre Persona wurde gelöscht. Bitte wählen Sie eine andere aus.',
      DELETED_PRESET_PLACEHOLDER: 'Modell nicht verfügbar. Bitte wählen Sie ein anderes.',
      SUBSCRIBE_PLACEHOLDER: 'Das ausgewählte KI-Modell ist mit dem aktuellen Abonnement nicht verfügbar.',
      SELECT_PERSONA: 'Wählen Sie eine Persona aus',
    },

    PRICING_CARD_GROUP: {
      WEEKLY: 'Pro Woche',
      MONTHLY: 'Pro Monat',
      YEARLY: 'Pro Jahr',
      SUBSCRIBE_PLAN: 'Plan abonnieren',
      UP_TO: 'Bis {{percent}}%',
      OFF: '{{percent}}% Rabatt',
    },

    PRICING_CARD: {
      MOST_POPULAR: 'Am beliebtesten',
      MY_SUBSCRIPTION: 'Mein Abonnement',
      SUBSCRIBE: 'Abonnieren',
      UNSUBSCRIBE: 'Abmelden',
      IN_ADDITION: 'Zusätzlich zu den vorherigen Stufen:',
      WEEKLY: 'Woche',
      MONTHLY: 'Monat',
      YEARLY: 'Jahr',
    },

    MY_PROFILE_CARD: {
      DATE_OF_BIRTH: 'Geburtsdatum:',
      REGISTERED: 'Registriert:',
      SUBSCRIBERS: 'Abonnenten',
      LIKES: 'Gefällt mir',
      MY_CHATBOTS: 'Meine Chatbots',
      MY_PUBLIC_PAGE: 'Meine öffentliche Seite',
      BALANCE: 'Kontostand:',
      ADD_TOKENS: 'Tokens hinzufügen',
    },
    CHAT_HEADER: {
      DISCLAIMER:
        'CAICHAT.AI basiert auf KI für kreatives Storytelling und Rollenspiele. Alle Gespräche sind fiktiv und sollten nicht als real oder faktisch betrachtet werden. Verantwortungsbewusst genießen!',
      SHOW_PREVIOUS: 'Vorherige anzeigen',
    },
    OVERLAY_INVITE_CODE: {
      TITLE: 'Deine Geschichte beginnt hier!',
      SUBTITLE: 'Nur noch ein Schritt, um erstaunliche Funktionen freizuschalten',
      ENTER_CODE: 'Gib deinen Einladungscode ein',
      INVITE_CODE: 'Einladungscode',
      LETS_GO: 'Los geht’s!',
      NEED_CODE: 'Benötigst du einen Einladungscode?',
      JOIN_DISCORD: 'Tritt Discord für den Zugriff bei',
      SIGN_OUT: 'Abmelden',
    },

    TOKEN_PACK_CARD: {
      BUY: 'Kaufen',
      SALE: 'Verkauf',
    },

    COMPARE_PLANS_TABLE: {
      MOST_POPULAR: 'Meistgewählt',
      FUNCTION_LIMIT: 'Funktion/Limit',
      INCLUDED_IN_PLAN: 'Im Plan enthalten',
      NOT_INCLUDED_IN_PLAN: 'Nicht im Plan enthalten',
      MAIN_FUNCTION: 'HAUPTFUNKTION',
      BONUS_FOR_SUB: 'Bonus-Token für Abonnement (bei Verlängerung)',
      UNLIMITED_MESSAGES: 'Unbegrenzte Nachrichten',
      COUPON_MONTH: 'Einmalkauf Gutschein mit 30-Tage-Abonnement',
      COUPON_YEAR: 'Einmalkauf Gutschein mit Jahresabonnement',
      USER_IDENTITIES: 'Nutzer-Personas',
      USER_IDENTITIES_TOOLTIP:
        'Nach Ablauf deines Abonnements wechselst du zum Free-Plan und kannst keine neuen Personas erstellen, bis du Platz freigibst.',
      ABILITY_TO_USE: 'Eigene Modelle verwenden',
      ACCESS_OTHER_EXTENSIONS: 'Zugriff auf andere und Standarderweiterungen',
      AVAILABLE_CONTEXT_TOKENS: 'Verfügbare Kontext-Tokens',
      AVAILABLE_LLM_TOKENS: 'Verfügbare LLM-Antworttokens',
      LIMITATION_ON_MODELS: 'EINSCHRÄNKUNGEN BEI MODELLEN',
      AVAILABLE_CHARACTERS: 'Verfügbare Charaktere',
      NO_RESTRICTIONS:
        'Keine Einschränkungen bei der Nutzung von Kontext, LLM-Antworten, Charakteren und System-Prompts mit eigenen KI-Modellen, außer den Einschränkungen im Abschnitt „Ihre KI-Modelle“',
      CREATE_EXTENSIONS: 'Eigene Erweiterungen erstellen',
      ADDITIONAL_FEATURES: 'ZUSÄTZLICHE FUNKTIONEN',
      SYSTEM_PROMPTS: 'System-Prompts',
      IMAGE_GEN: 'Bildgenerierung für Tokens verfügbar – eine bestimmte Anzahl von Bildern pro Tag kostenlos (Limit pro Monat/Woche)',
      AVATAR_GEN_ALL: 'Avatar-Erstellung für alle Charaktere, einschließlich privater',
      CHAT_ENCRYPTION: 'Chat-Verschlüsselung',
      ACCESS_EXTENSIONS: 'Zugriff auf Erweiterungen',
      ACCESS_MEMORY_MANAGER: 'Zugriff auf den Memory-Manager (Memories) mit Möglichkeit eigene Einträge hinzuzufügen',
      SEMANTIC_MEMORY: 'Semantisches Gedächtnis 2.0',
      TTS: 'Text-zu-Sprache (Antworten vertonen)',
      CREATE_PRIVATE_CHARACTERS: 'Eigene private Charaktere erstellen',
      CREATE_PUBLIC_CHARACTERS: 'Eigene öffentliche Charaktere erstellen',
      AD_FREE: 'Werbefrei',
      NO_QUEUE: 'Keine Warteschlange',
      ADDITIONAL_TOOLS: 'Zusätzliche Werkzeuge zur Erstellung von Charakteren und Erweiterungen',
      LIMITED_EDITION_MODEL: 'Limited Edition Modell',
      UP_TO_200: 'bis zu 200',
      UNLIMITED: 'Unbegrenzt',
      UP_TO_1_PER_DAY: 'Bis zu 1 kostenlos pro Tag',
      ONLY_YOUR_OWN_AND_FREE: 'Nur eigene und kostenlose',
      RECOMMENDED_MODELS_WITHOUT_LIMITATIONS: 'Unsere Empfehlungen ohne Token-Beschränkungen',
      UP_TO_5_PER_DAY_PLUS_UNLIMITED_FOR_FEE: 'Bis zu 5 pro Tag + unbegrenzt gegen Gebühr',
      ONLY_SPEECH: 'Nur Sprache',
      UNLIMITED_LOW_QUALITY: 'Unbegrenzt, niedrige Qualität',
      UNLIMITED_MEDIUM_QUALITY: 'Unbegrenzt, mittlere Qualität',
      UNLIMITED_HIGH_QUALITY: 'Unbegrenzt, hohe Qualität',
      TEN_PERCENT_DISCOUNT_ONE_WEEK: '10% Rabatt für eine Woche',
      MONTHLY_COUPON_TEN_PERCENT_DISCOUNT: 'Monatlicher Gutschein: 10% Rabatt auf Tokens für eine Woche',
      TWENTY_PERCENT_DISCOUNT_ONE_WEEK: '20% Rabatt für eine Woche',
      MONTHLY_COUPON_TWENTY_PERCENT_DISCOUNT: 'Monatlicher Gutschein: 20% Rabatt auf Tokens für eine Woche',
      THE_ENTIRE_ANSWER: 'Die gesamte Antwort',
      THIRTY_PERCENT_DISCOUNT_ONE_WEEK: '30% Rabatt für eine Woche',
      MONTHLY_COUPON_THIRTY_PERCENT_DISCOUNT: 'Monatlicher Gutschein: 30% Rabatt auf Tokens für eine Woche',
      AVAILABLE_CHARACTERS_TOOLTIP:
        'Charaktere, für die mehr als 2000 Tokens für Persönlichkeit und mehr als 3000 Tokens für Begrüßungen verwendet wurden (basierend auf dem höheren Wert), können keine kostenlosen Modelle verwenden.',
      UP_TO_5k_TOKENS: 'Bis zu 5000 Tokens, die für Persönlichkeit verwendet wurden',
      UP_TO_5k_TOKENS_ACTIVE: 'Bis zu 5000 Tokens für Persönlichkeit + Active-Tier-Modelle',
      UP_TO_5k_TOKENS_DREAMER: 'Bis zu 5000 Tokens für Persönlichkeit + Dreamer-Tier-Modelle',
      UP_TO_5k_TOKENS_CREATOR: 'Bis zu 5000 Tokens für Persönlichkeit + Creator-Tier-Modelle',
      UP_TO_5k_TOKENS_STORY_GOD: 'Bis zu 5000 Tokens für Persönlichkeit + Story-GOD-Tier-Modelle',
      ACTIVE: 'Aktiv',
      FREE_PLAN: 'Kostenloser',
      FREE_MODELS: 'Kostenlose Modelle',
      FREE_MODELS_FREE: 'Kostenlose Modelle für Charaktere mit einer Persönlichkeit von bis zu 5000 Tokens',
      FREE_MODELS_ACTIVE: 'Modelle des kostenlosen Plans + Modelle der Stufe Aktiv',
      FREE_MODELS_DREAMER: 'Modelle des kostenlosen Plans + Modelle der Stufe Träumer',
      FREE_MODELS_CREATOR: 'Modelle des kostenlosen Plans + Modelle der Stufe Schöpfer',
      FREE_MODELS_STORY_GOD: 'Modelle des kostenlosen Plans + Modelle der Stufe Story-Gott',
    },
    MODEL_PROMPT_PRESET: {
      MODEL: 'Modell',
      DEFAULT: 'Standard',
      RECOMMENDED: 'Empfohlen',
      PRESET: 'Preset',
      LAST_USED: 'Zuletzt verwendet',
      SUCCESS: 'Einstellungen erfolgreich angewendet!',
      ERROR: 'Einstellungen konnten nicht angewendet werden!',
      INCOMPATIBLE: 'Nicht kompatibel mit dem KI-Modell',
      WE_RECOMMEND: 'Wir empfehlen',
      AUTHORS_CHOICE: 'Wahl des Autors',
      POPULAR: 'Beliebt',
      UNSUITABLE_SUBSCRIPTION: 'Ihr Abonnementplan ist für dieses Modell nicht geeignet.',
    },
    PUBLIC_PROFILE_HEADER: {
      COPIED: 'kopiert',
      SUBSCRIBERS: 'Abonnenten',
      LIKES: 'Gefällt mir',
      CHATBOTS: 'Chatbots',
      YOU_HAVE_BLOCKED_THIS_AUTHOR: 'Du hast diesen Autor blockiert. ',
      UNBLOCK: 'Freischalten',
    },
    PROMPTS_BLOCK: {
      REPLACE: 'KI-Modell ersetzen',
      SELECT: 'KI-Modell auswählen',
    },
    FILE_UPLOAD: {
      UPLOAD: 'Hochladen',
    },
    SUBSCRIBE_BOOSTY: {
      CAN_SUBSCRIBE: 'Sie können auch über Boosty ein Abonnement abschließen, das flexible Optionen für Ihre Bedürfnisse bietet.',
      HAVE_SUBSCRIBE: 'Sie haben bereits ein Abonnement über Boosty. Ihr Abonnement ist gültig bis:',
      GO_TO_BOOSTY: 'Zu Boosty gehen',
      SUBSCRIBE_TO_BOOSTY: 'Boosty abonnieren',
    },
    TAGS_SELECT: {
      TAGS: 'Tags',
      PLACEHOLDER: 'Markieren Sie Ihren Charakter mit relevanten Stichwörtern (maximal 10 Tags insgesamt)',
      CREATE_NEW: 'Neu erstellen – ',
      LIMIT: 'Maximal 10 Tags insgesamt',
      CUSTOM_TAG_VALIDATION: 'Benutzerdefinierte Tags müssen zwischen 3 und 20 Zeichen lang sein (nur alphanumerisch).',
    },
  },
  UTILS: {
    SMART_DATE_FORMAT: {
      JUST_NOW: 'Gerade eben',
      MINUTES_AGO: 'vor {{count}} {{minutes}}',
      HOURS_AGO: 'vor {{count}} {{hours}}',
      DAYS_AGO: 'vor {{count}} {{days}}',
      WEEKS_AGO: 'vor {{count}} {{weeks}}',
      MONTHS_AGO: 'vor {{count}} {{months}}',
      ONE_MINUTES: 'minute',
      FEW_MINUTES: 'minuten',
      MANY_MINUTES: 'minuten',
      ONE_HOURS: 'stunde',
      FEW_HOURS: 'stunden',
      MANY_HOURS: 'stunden',
      ONE_DAYS: 'tag',
      FEW_DAYS: 'tage',
      MANY_DAYS: 'tage',
      ONE_WEEK: 'woche',
      FEW_WEEKS: 'wochen',
      MANY_WEEKS: 'wochen',
      ONE_MONTH: 'monat',
      FEW_MONTHS: 'monate',
      MANY_MONTHS: 'monate',
    },
    SMART_MESSAGE_FORMAT: {
      ONE_MESSAGES: 'nachricht',
      FEW_MESSAGES: 'nachrichten',
      MANY_MESSAGES: 'nachrichten',
    },
    TIME: {
      H: 'h',
      M: 'm',
      S: 's',
    },
  },
  NOTIFICATIONS: {
    CHATBOT_CREATE: {
      SUCCESS: 'Chatbot "{{name}}" erfolgreich erstellt!',
      UPDATE_SUCCESS: 'Chatbot erfolgreich aktualisiert!',
      UPDATE_ERROR: 'Fehler beim Aktualisieren des Chatbots!',
      REQUIRED_FIELDS: 'Pflichtfelder müssen ausgefüllt werden:',
    },
    CHAT_MESSAGE: {
      NEW_CHAT_STARTED: 'Eine neue Konversation wurde von der ausgewählten Nachricht gestartet!',
      ERROR: 'Bei der Verarbeitung der Anfrage ist ein Fehler aufgetreten',
      REPORT_MESSAGE_SENT: 'Ihr Bericht wurde übermittelt',
      ENCRYPTION_SAVE: 'Ihre Verschlüsselungseinstellungen wurden erfolgreich gespeichert.',
      ENCRYPTION_DELETE: 'Verschlüsselung wurde abgebrochen.',
      ENCRYPTION_LIMIT:
        'Du hast das Limit für verschlüsselte Chats erreicht! Entschlüssele einige Chats oder upgrade deinen Tarif, um weitere zu verschlüsseln.',
    },
    TEXT_TO_SPEECH_ERROR:
      'Wir konnten nicht auf Ihr Mikrofon zugreifen. Bitte überprüfen Sie Ihre Browser- oder Geräteberechtigungen, um die Spracherkennung zu aktivieren.',
    PASSWORD_CHANGED: 'Passwort erfolgreich geändert',
    FAILED_TO_LOAD_IMAGE: 'Bild konnte nicht geladen werden!',
    COPIED_TO_CLIPBOARD: 'In die Zwischenablage kopiert',
  },
  COMMON: {
    ADD: 'Hinzufügen',
    OR: 'oder',
    AND: 'und',
    BY: 'von',
    FREE: 'KOSTENLOS',
    EXAMPLE: 'Beispiel',
    CONTINUE: 'Fortfahren',
    CONFIRM: 'Bestätigen',
    SUBMIT: 'Absenden',
    DELETE: 'Löschen',
    DELETED: 'Gelöscht',
    SAVE: 'Speichern',
    REGENERATE: 'Neu generieren',
    GENERATE: 'Generieren',
    GENERATION: 'Generation...',
    GENERATING: 'Wird generiert',
    CREATE: 'Erstellen',
    CANCEL: 'Abbrechen',
    COPY: 'Kopieren',
    COPIED: 'Kopiert',
    BACK: 'Zurück',
    LOG_IN: 'Einloggen',
    SIGN_IN: 'Anmelden',
    SIGN_UP: 'Registrieren',
    SIGN_IN_WITH: 'Mit {{ provider }} anmelden',
    PASSWORD: 'Passwort',
    CONFIRM_PASSWORD: 'Passwort bestätigen',
    NOT_AVAILABLE: 'Nicht verfügbar',
    CLOSE: 'Schließen',
    MIN: 'Min',
    MAX: 'Max',
    PLACEHOLDER: {
      SEARCH: 'Suchen...',
    },
    FILE_INPUT: {
      INVALID_FILE_TYPE: 'Datei {{fileName}} hat einen ungültigen Typ. Erlaubte Typen: {{allowedTypes}}',
      MAX_FILE_SIZE: 'Datei {{fileName}} überschreitet die maximale Größe von {{maxSize}}MB',
      DRAG_AND_DROP_TO_UPLOAD_IMAGE: 'Ziehen und ablegen oder klicken, um ein Bild hochzuladen',
      DROP_FILE: 'Datei hier ablegen',
      CHOOSE_FILE: 'Datei auswählen',
    },
    ERROR: {
      INVALID_FIELD: 'Feld ist ungültig',
      FILLED_IN: 'Feld muss ausgefüllt werden',
      MIN_LENGTH: 'Mindestlänge beträgt {{length}} Zeichen',
      MAX_LENGTH: 'Maximallänge beträgt {{length}} Zeichen',
      NO_SPACES: 'Feld darf nicht mit Leerzeichen beginnen oder enden und darf nicht nur aus Leerzeichen bestehen',
      INVALID_EMAIL: 'Ungültige E-Mail-Adresse',
      INVALID_CURRENT_PASSWORD: 'Das aktuelle Passwort ist ungültig',
      INVALID_USERNAME: 'Ungültiger Benutzername',
      INVALID_USERNAME_EXPANDED:
        'Der Benutzername muss zwischen 3 und 20 Zeichen lang sein und darf nur lateinische Buchstaben (a–z), Zahlen und Bindestriche enthalten',
      PASS_NOT_CHANGED: 'Das neue Passwort muss sich vom alten unterscheiden',
      DUMB_ERROR: 'Etwas ist schiefgelaufen',
      PASSWORD_MISMATCH: 'Passwörter stimmen nicht überein.',
      INVALID_PASSWORD:
        'Die Passwortlänge muss zwischen {{minLength}} und {{maxLength}} Zeichen liegen. Erlaubt sind nur A-Z, a-z, 0-9 und Sonderzeichen.',
      INVALID_EMAIL_OR_PASSWORD: 'Ungültige E-Mail-Adresse oder ungültiges Passwort',
      FIELD_BETWEEN: 'Die Länge muss zwischen {{minLength}} und {{maxLength}} Zeichen liegen.',
      PASS_MISMATCH: 'Passwörter stimmen nicht überein',
      VALUE_MUST_BE_BETWEEN: 'Der Wert muss zwischen {{min}} und {{max}} liegen',
      LOADING_ERROR: 'Ladefehler',
      NOT_ENOUGH_TOKENS: 'Sie haben nicht genügend Tokens, um ein Bild zu generieren. Bitte fügen Sie Ihrem Konto weitere Tokens hinzu.',
      NO_ITEMS_AVAILABLE: 'Keine Elemente verfügbar',
    },
    MONTH: {
      JANUARY: 'Januar',
      FEBRUARY: 'Februar',
      MARCH: 'März',
      APRIL: 'April',
      MAY: 'Mai',
      JUNE: 'Juni',
      JULY: 'Juli',
      AUGUST: 'August',
      SEPTEMBER: 'September',
      OCTOBER: 'Oktober',
      NOVEMBER: 'November',
      DECEMBER: 'Dezember',
    },
    WEEK: {
      MONDAY: 'Mo',
      TUESDAY: 'Di',
      WEDNESDAY: 'Mi',
      THURSDAY: 'Do',
      FRIDAY: 'Fr',
      SATURDAY: 'Sa',
      SUNDAY: 'So',
    },
  },
  FAQ: {
    TOPIC1: {
      QUESTION: 'Wie funktioniert die Änderung des Abonnement-Plans?',
      ANSWER:
        'Die Änderung des Abonnement-Plans ist jederzeit möglich: Bei einem Upgrade auf eine höhere Stufe — die Aktivierung erfolgt sofort nach Zahlung der Differenz für die verbleibende Zeit. Bei einem Downgrade — die Aktivierung erfolgt nach Ende der aktuellen Periode.',
    },
    TOPIC2: {
      QUESTION: 'Verfällt die Bonus-Energie nach Ende des Abonnements?',
      ANSWER:
        'Nein, die Bonus-Energie verfällt nicht — Sie können sie auch nach Ende des Abonnements weiter nutzen. Wenn Sie ein neues Abonnement abschließen, erhalten Sie eine neue Portion Bonus-Energie.',
    },
    TOPIC3: {
      QUESTION: 'Verlängert sich das Abonnement automatisch?',
      ANSWER:
        'Ja, das Abonnement verlängert sich automatisch für Ihre Bequemlichkeit, damit Sie den Zugang zu den Funktionen nicht verlieren. Sie können die automatische Verlängerung jedoch jederzeit in den Einstellungen deaktivieren. Der Zugang zu den Abonnement-Funktionen bleibt bis zum Ende der bezahlten Periode bestehen.',
    },
    TOPIC4: {
      QUESTION: 'Haben Sie noch weitere Fragen?',
      ANSWER: 'Wenn Sie Hilfe benötigen, wenden Sie sich an unseren Support-Service.',
      BUTTON: 'Frage stellen',
    },
  },
  FAQ_PROFILE: {
    TOPIC1: {
      QUESTION: 'Kann ich meinen Plan upgraden oder downgraden?',
      ANSWER: 'Der Text wird in Kürze verfügbar sein. Bei Fragen kontaktieren Sie uns bitte per E-Mail unter support@caichat.ai',
    },
    TOPIC2: {
      QUESTION: 'Wie kann ich meinen Plan kündigen?',
      ANSWER: 'Der Text wird in Kürze verfügbar sein. Bei Fragen kontaktieren Sie uns bitte per E-Mail unter support@caichat.ai',
    },
    TOPIC3: {
      QUESTION: 'Kann ich mein Abonnement kündigen und trotzdem die Planvorteile bis zum Ende des aktuellen Abrechnungszeitraums behalten?',
      ANSWER: 'Der Text wird in Kürze verfügbar sein. Bei Fragen kontaktieren Sie uns bitte per E-Mail unter support@caichat.ai',
    },
    TOPIC4: {
      QUESTION: 'Wie erhalte ich eine Rückerstattung?',
      ANSWER: 'Der Text wird in Kürze verfügbar sein. Bei Fragen kontaktieren Sie uns bitte per E-Mail unter support@caichat.ai',
    },
    TOPIC5: {
      QUESTION: 'Ich habe weitere Fragen.',
      ANSWER: 'Wenn Sie Hilfe benötigen, klicken Sie auf den Button unten. Unser Support-Team hilft Ihnen gerne weiter.',
      BUTTON: 'Frage stellen',
    },
  },
  BACKEND_MESSAGES: {
    INVALID_PASSWORD: 'Ungültiges Passwort',
    SLUG_ALREADY_TAKEN: 'Slug {{ slug }} ist bereits von einem anderen Benutzer vergeben',
    TOKENS_EXCEEDED:
      'Das ausgewählte Modell ist für diesen Charakter nicht verfügbar. Kostenlose Modelle sind für diesen Charakter blockiert. Der gesamte Kontext ({{number}} Tokens) überschreitet das Limit (5000). Bitte verwenden Sie ein bezahltes Modell.',
    NOT_ENOUGH_TOKENS: 'Sie haben nicht genügend Tokens, um dieses Bild zu erzeugen',
  },
};
